import { Link } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
import classNames from 'classnames';
import breakpoints from '../utils/breakpoints';
import industries from '../utils/industries';
import { stripTagParents, toSlug } from '../utils/tag';
import { trackEvent } from '../utils/track';
import { DASHBOARD_ROLE_GROUP } from '../utils/user';
import IsRole from './is-role';
import * as Styles from './nav.module.scss';

function Nav() {
  const location = useLocation();
  const navCareerDev = useRef();
  const industryChildren = useRef();
  const toolkitChildren = useRef();
  const familiesChildren = useRef();
  // const familiesChildrenDots = useRef();
  const navIndustry = useRef();
  const navProfile = useRef();
  const navFamilies = useRef();
  const threeDotsChildren = useRef();
  const navThreeDots = useRef();
  const navMeetUp = useRef();
  const [isIndustryActive, setIsIndustryActive] = useState(false);
  const [isIndustryOpen, setIsIndustryOpen] = useState(false);
  const [isFamiliesActive, setIsFamiliesActive] = useState(false);
  const [isFamiliesOpen, setIsFamiliesOpen] = useState(false);
  const [isToolkitActive, setIsToolkitActive] = useState(false);
  const [isToolkitOpen, setIsToolkitOpen] = useState(false);
  const [isDotsOpen, setIsDotsOpen] = useState(false);
  const [isFamiliesOpenDots, setIsFamiliesOpenDots] = useState(false);
  const [isDotsActive, setIsDotsActive] = useState(false);
  const [isDotsActiveFirst, setIsDotsActiveFirst] = useState(false);

  useEffect(() => {
    const documentClick = () => {
      if (isIndustryOpen && window.matchMedia(breakpoints.sm).matches) {
        setIsIndustryOpen(false);
      }
    };

    window.addEventListener('click', documentClick);

    return () => {
      window.removeEventListener('click', documentClick);
    };
  }, [isIndustryOpen]);

  useEffect(() => {
    const documentClick = () => {
      if (isToolkitOpen && window.matchMedia(breakpoints.sm).matches) {
        setIsToolkitOpen(false);
      }
    };

    window.addEventListener('click', documentClick);

    return () => {
      window.removeEventListener('click', documentClick);
    };
  }, [isToolkitOpen]);

  useEffect(() => {
    const documentClick = () => {
      if (isFamiliesOpen && window.matchMedia(breakpoints.sm).matches) {
        setIsFamiliesOpen(false);
      }
    };

    window.addEventListener('click', documentClick);

    return () => {
      window.removeEventListener('click', documentClick);
    };
  }, [isFamiliesOpen]);

  useEffect(() => {
    const documentClick = () => {
      if (isDotsOpen && isFamiliesOpenDots && window.matchMedia(breakpoints.sm).matches) {
        setIsDotsOpen(false);
      }
    };

    window.addEventListener('click', documentClick);

    return () => {
      window.removeEventListener('click', documentClick);
    };
  }, [isFamiliesOpenDots]);

  useEffect(() => {
    const isLocation = location.pathname.match(/\/industries\//);
    setIsIndustryActive(isLocation);

    if (isLocation && !window.matchMedia(breakpoints.sm).matches) {
      setIsIndustryOpen(true);
    }
  }, [location]);

  useEffect(() => {
    const isLocation = location.pathname.match(/\/families-educators($|\/)/);
    setIsFamiliesActive(isLocation);

    if (isLocation && !window.matchMedia(breakpoints.sm).matches) {
      setIsFamiliesOpen(true);
    }
  }, [location]);

  useEffect(() => {
    const isLocation = location.pathname.match(
      /\/career-development($|\/)|\/skills-explorer($|\/)|\/power-skills($|\/)/
    );
    setIsToolkitActive(isLocation);

    if (isLocation && !window.matchMedia(breakpoints.sm).matches) {
      setIsToolkitOpen(true);
    }
  }, [location]);

  useEffect(() => {
    setIsDotsActiveFirst(location.pathname.match(/\/meetups($|\/)/));
  }, [location]);

  useEffect(() => {
    setIsDotsActive(location.pathname.match(/\/ask-me-anything($|\/)/));
  }, [location]);

  // @TODO hard-coded list of industries to circumvent staticQuery bug in Gatsby
  // const industriesQuery = useStaticQuery(graphql`
  //   query {
  //     allContentfulIndustry(sort: { fields: order }, filter: { title: { regex: "/^(?!___PLACEHOLDER___)/i" } }) {
  //       nodes {
  //         id
  //         title
  //         order
  //         metadata {
  //           tags {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }
  //   }
  // `);
  // const industries = industriesQuery.allContentfulIndustry.nodes;

  const trackClick = (label) => {
    trackEvent('Menu Click', 'Navigation Action Taken', label);
  };

  return (
    <nav className={Styles.root}>
      <ul className={Styles.navItems}>
        <li className={classNames(Styles.navItem, Styles.navSearch)}>
          <Link
            to="/search"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            onClick={() => {
              trackClick('Search');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>Search</span>
          </Link>
        </li>
        <li className={classNames(Styles.navItem, Styles.navAbout)}>
          <Link
            to="/about"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            onClick={() => {
              trackClick('About');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>About</span>
          </Link>
        </li>
        <li className={classNames(Styles.navItem, Styles.navGettingStarted)}>
          <Link
            to="/getting-started"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            onClick={() => {
              trackClick('Getting Started');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>Getting Started</span>
          </Link>
        </li>

        <li className={classNames(Styles.navItem, Styles.navFamilies, Styles.navItemHasChildren)} ref={navFamilies}>
          <button
            className={classNames(Styles.navItemLink, {
              [Styles.navItemLinkActive]: isFamiliesActive,
              [Styles.navItemLinkHighlight]: isFamiliesOpen,
            })}
            onClick={() => {
              trackClick('Resources');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(!isFamiliesOpen);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
            type="button"
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>Resources</span>
          </button>
          <div className={Styles.navChildrenContainer}>
            <ul className={Styles.navChildren} data-open={isFamiliesOpen} ref={familiesChildren}>
              <li className={Styles.navChild}>
                <Link
                  to="/families-educators/resources/educators/"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  onClick={() => trackClick('In Schools')}
                  partiallyActive
                >
                  <span>For Educators</span>
                </Link>
              </li>
              <li className={Styles.navChild}>
                <Link
                  to="/families-educators/resources/families/"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  onClick={() => trackClick('Beyond the Classroom')}
                  partiallyActive
                >
                  <span>Beyond the Classroom</span>
                </Link>
              </li>
              <li className={Styles.navChild}>
                <Link
                  to="/faq"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  onClick={() => trackClick('FAQ')}
                >
                  <span>FAQ</span>
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <IsRole roles={DASHBOARD_ROLE_GROUP}>
          <li className={classNames(Styles.navItem, Styles.navDashboard)}>
            <Link
              to="/dashboard"
              className={Styles.navItemLink}
              activeClassName={Styles.navItemLinkActive}
              partiallyActive
              onClick={() => {
                trackClick('Dashboard');
                window.requestAnimationFrame(() => {
                  setIsIndustryOpen(false);
                  setIsFamiliesOpen(false);
                  setIsToolkitOpen(false);
                  setIsDotsOpen(false);
                });
              }}
            >
              <span className={Styles.navItemIcon} />
              <span className={Styles.navItemText}>Teacher Dashboard</span>
            </Link>
          </li>
        </IsRole>

        <li className={classNames(Styles.navItem, Styles.navHome)}>
          <Link
            to="/"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            onClick={() => {
              trackClick('Home');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>My Feed</span>
          </Link>
        </li>

        <li className={classNames(Styles.navItem, Styles.navCareerDev, Styles.navItemHasChildren)} ref={navCareerDev}>
          <button
            className={classNames(Styles.navItemLink, {
              [Styles.navItemLinkActive]: isToolkitActive,
              [Styles.navItemLinkHighlight]: isToolkitOpen,
            })}
            onClick={() => {
              trackClick('Families & Educators');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsToolkitOpen(!isToolkitOpen);
                setIsFamiliesOpen(false);
                setIsDotsOpen(false);
              });
            }}
            type="button"
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>My Tool Kit</span>
          </button>
          <div className={Styles.navChildrenContainer}>
            <ul className={Styles.navChildren} data-open={isToolkitOpen} ref={toolkitChildren}>
              <li className={Styles.navChild}>
                <Link
                  to="/skills-explorer"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  partiallyActive
                  onClick={() => trackClick('Skills Explorer')}
                >
                  <span>Skills Explorer</span>
                </Link>
              </li>
              <li className={Styles.navChild}>
                <Link
                  to="/power-skills"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  partiallyActive
                  onClick={() => trackClick('Power Skills')}
                >
                  <span>Power Skills Courses</span>
                </Link>
              </li>
              <li className={Styles.navChild}>
                <Link
                  to="/career-development"
                  className={Styles.navChildLink}
                  activeClassName={Styles.navChildLinkActive}
                  partiallyActive
                  onClick={() => trackClick('Career Development')}
                >
                  <span>Career Development</span>
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <li className={classNames(Styles.navItem, Styles.navIndustries, Styles.navItemHasChildren)} ref={navIndustry}>
          <button
            className={classNames(Styles.navItemLink, {
              [Styles.navItemLinkActive]: isIndustryActive,
              [Styles.navItemLinkHighlight]: isIndustryOpen,
            })}
            onClick={() => {
              trackClick('Industries');
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(!isIndustryOpen);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
            type="button"
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>Industries</span>
          </button>
          <div className={Styles.navChildrenContainer}>
            <ul className={Styles.navChildren} data-open={isIndustryOpen} ref={industryChildren}>
              {industries
                .sort((a, b) => {
                  return a.title.localeCompare(b.title);
                })
                .map((industry) => {
                  if (industry.metadata.tags.length === 0) {
                    return null;
                  }

                  return (
                    <li key={industry.id} className={Styles.navChild}>
                      <Link
                        to={`/industries/${toSlug(stripTagParents(industry.metadata.tags[0].name))}/`}
                        className={Styles.navChildLink}
                        activeClassName={Styles.navChildLinkActive}
                        onClick={() => trackClick(industry.title)}
                      >
                        <span>{industry.title}</span>
                        {/* <span className={Styles.spanSubtitle}>{industry.subtitle}</span> */}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </div>
        </li>

        <li className={classNames(Styles.navItem, Styles.navProfile)} ref={navProfile}>
          <Link
            to="/profile"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            partiallyActive
            onClick={() => {
              trackClick('Profile');
              setIsIndustryOpen(false);
              setIsFamiliesOpen(false);
              setIsToolkitOpen(false);
              setIsDotsOpen(false);
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>My Profile & Badges</span>
          </Link>
        </li>

        {/* Nav meetups */}
        <li className={classNames(Styles.navItem, Styles.navMeetUp)} ref={navMeetUp}>
          <Link
            to="/meetups"
            className={Styles.navItemLink}
            activeClassName={Styles.navItemLinkActive}
            partiallyActive
            onClick={() => {
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(false);
              });
            }}
          >
            <span className={Styles.navItemIcon} />
            <span className={Styles.navItemText}>Meetups</span>
          </Link>
        </li>

        {/* New nav route */}
        <li className={classNames(Styles.navItem, Styles.navThreeDots)} ref={navThreeDots}>
          <button
            className={classNames(Styles.navItemLink, {
              [Styles.navItemLinkActive]: isDotsActive || isDotsActiveFirst,
              [Styles.navItemLinkHighlight]: isDotsOpen,
            })}
            onClick={() => {
              window.requestAnimationFrame(() => {
                setIsIndustryOpen(false);
                setIsFamiliesOpen(false);
                setIsToolkitOpen(false);
                setIsDotsOpen(!isDotsOpen);
                setIsFamiliesOpenDots(false);
              });
            }}
            type="button"
          >
            <span className={Styles.navItemIcon} />
          </button>
          <div>
            <ul
              className={classNames(Styles.navChildren, Styles.navChildrenDots)}
              data-open={isDotsOpen}
              ref={threeDotsChildren}
            >
              <li className={classNames(Styles.navChild, Styles.navMeetUp)} ref={navMeetUp}>
                <Link
                  to="/meetups"
                  className={Styles.navItemLinkDots}
                  activeClassName={Styles.navItemLinkActiveDots}
                  partiallyActive
                  onClick={() => {
                    window.requestAnimationFrame(() => {
                      setIsDotsOpen(false);
                      setIsIndustryOpen(false);
                      setIsFamiliesOpen(false);
                    });
                  }}
                >
                  <span className={classNames(Styles.navItemIcon, Styles.navItemIconDots)} />
                  <span>Meetups</span>
                </Link>
              </li>

              {/*
              <li className={classNames(Styles.navItem, Styles.navFamilies)} ref={navFamilies}>
                <button
                  className={classNames(Styles.navItemLinkDots, {
                    [Styles.navItemLinkActiveDots]: isDotsActiveFirst,
                    [Styles.navItemLinkHighlightDots]: isFamiliesOpenDots,
                  })}
                  onClick={() => {
                    trackClick('Resources');
                    window.requestAnimationFrame(() => {
                      setIsFamiliesOpenDots(!isFamiliesOpenDots);
                    });
                  }}
                  type="button"
                >
                  <span className={classNames(Styles.navItemIcon, Styles.navItemIconDots)} />
                  <span>Resources</span>
                </button>
                <div className={Styles.navChildrenContainer}>
                  <ul className={Styles.navChildrenDotsChild} data-open={isFamiliesOpenDots} ref={familiesChildrenDots}>
                    <li className={Styles.navChild}>
                      <Link
                        to="/families-educators/resources/educators/"
                        className={Styles.navChildLinkDots}
                        activeClassName={Styles.navChildLinkActive}
                        onClick={() => {
                          trackClick('In Schools');
                          setIsDotsOpen(false);
                        }}
                        partiallyActive
                      >
                        <span>For Educators</span>
                      </Link>
                    </li>
                    <li className={Styles.navChild}>
                      <Link
                        to="/families-educators/resources/families/"
                        className={Styles.navChildLinkDots}
                        activeClassName={Styles.navChildLinkActive}
                        onClick={() => {
                          trackClick('Beyond the Classroom');
                          setIsDotsOpen(false);
                        }}
                        partiallyActive
                      >
                        <span>Beyond the Classroom</span>
                      </Link>
                    </li>
                    <li className={Styles.navChild}>
                      <Link
                        to="/families-educators/about/"
                        className={Styles.navChildLinkDots}
                        activeClassName={Styles.navChildLinkActive}
                        onClick={() => {
                          trackClick('About');
                          setIsDotsOpen(false);
                        }}
                      >
                        <span>About</span>
                      </Link>
                    </li>
                    <li className={Styles.navChild}>
                      <Link
                        to="/single-sign-on-faq"
                        className={Styles.navChildLinkDots}
                        activeClassName={Styles.navChildLinkActive}
                        onClick={() => {
                          trackClick('SSO FAQ');
                          setIsDotsOpen(false);
                        }}
                      >
                        <span>SSO FAQ</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              */}
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
